import { Instagram, Mail, MapPin } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { InquiryForm } from "@/components/InquiryForm";
import { Reveal } from "@/components/Motion";
import { INSTAGRAM, HANDLE, EMAIL } from "@/data/site";

const Item = ({ icon: Icon, title, children }) => (
  <div className="flex gap-5 border-t border-espresso/15 pt-6">
    <Icon className="w-5 h-5 text-gold mt-1 shrink-0" strokeWidth={1.4} />
    <div><p className="eyebrow mb-2">{title}</p>{children}</div>
  </div>
);

export default function Contact() {
  return (
    <main data-testid="contact-page">
      <PageHero eyebrow="Contact" lines={["Let’s", <span className="italic text-mocha">talk dessert.</span>]} intro="Questions about an order, pickup or something special? Send a note and Lise will reply by email." />
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pb-28 grid lg:grid-cols-12 gap-16">
        <Reveal className="lg:col-span-4 space-y-8">
          <Item icon={MapPin} title="Studio"><p className="font-display text-2xl">Clifton Heights, PA</p><p className="text-mocha text-sm mt-1">Pickup only. Pickup details are sent once payment is received.</p></Item>
          <Item icon={Mail} title="Email"><a href={`mailto:${EMAIL}`} data-testid="contact-email" className="font-display text-2xl link-u break-all">{EMAIL}</a></Item>
          <Item icon={Instagram} title="Instagram"><a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="contact-instagram" className="font-display text-2xl link-u">{HANDLE}</a></Item>
        </Reveal>
        <Reveal className="lg:col-span-7 lg:col-start-6 bg-linen p-6 sm:p-10 md:p-14">
          <InquiryForm kind="contact" />
        </Reveal>
      </section>
    </main>
  );
}
